import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { Box } from '@mui/material'
import { GameVariantTabViews, RoulettesTable, RpGamesTable } from '../../components'
import { EGameVariant } from '../../constants/gameVariant'

const Games: FC = observer(() => {
  const content = {
    [EGameVariant.ROULETTE]: <RoulettesTable />,
    [EGameVariant.RUSSIAN_POKER]: <RpGamesTable />,
  }

  return (
    <Box>
      <GameVariantTabViews tabContent={content} />
    </Box>
  )
})

export default Games
